import { render, staticRenderFns } from "./SearchMaterialSearch.vue?vue&type=template&id=23ce86c7"
import script from "./SearchMaterialSearch.vue?vue&type=script&lang=js"
export * from "./SearchMaterialSearch.vue?vue&type=script&lang=js"
import style0 from "./SearchMaterialSearch.vue?vue&type=style&index=0&id=23ce86c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports